/**
 * Remembering that someone said "not now".
 *
 * Per device rather than per person, because what is being answered is a
 * question about this device: whether to install it, whether it should buzz.
 * Both nudges are one-shot — dismissing means dismissed for good, and the
 * Notifications screen in Tools stays available for anyone who changes their
 * mind.
 *
 * Storage is wrapped because it is not always there: Safari throws on
 * `localStorage` in some private-browsing configurations, and a banner is never
 * worth crashing the app over.
 */

export const INSTALL_NUDGE = "roofboard.nudge.install";
export const PUSH_NUDGE = "roofboard.nudge.push";

export function wasDismissed(key: string): boolean {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function markDismissed(key: string): void {
  try {
    localStorage.setItem(key, "1");
  } catch {
    // Nothing to do: the nudge simply asks again next time.
  }
}
